let activeId = null;
const listeners = new Set();

export const claimVoicePlayback = (playerId) => {
  activeId = playerId;
  listeners.forEach((listener) => listener(playerId));
};

export const releaseVoicePlayback = (playerId) => {
  if (activeId === playerId) {
    activeId = null;
  }
};

export const subscribeVoicePlayback = (handler) => {
  listeners.add(handler);
  return () => listeners.delete(handler);
};
